import { useForm, Controller } from "react-hook-form";
import Filter from "./Filter"
import { Autocomplete, Box, Checkbox, TextField, Typography } from "@mui/material";
export const FilterCompanyService = ({ onFilter, status = [] }) => {

    const defaultValues = {
        id: "",
        name: "",
        description: "",
        cost: "",
        custom_status_id: "",
        active: undefined,
        hours: "",
        minutes: "",

    }

    const methods = useForm({ defaultValues });

    return (
        <Filter onFilter={methods.handleSubmit(onFilter)} onClear={() => methods.reset(defaultValues)}>
            <Box display='flex' flexDirection='column' className='gap-1'>
                
                <TextField
                    id="id"
                    label="Id"
                    variant="outlined"
                    name="id"
                    {...methods.register("id")}
                />
                
                <TextField
                    id="name"
                    label="Nome"
                    variant="outlined"
                    name="name"
                    {...methods.register("name")}
                />

                <TextField
                    id="description"
                    label="Descrição"
                    variant="outlined"
                    name="description"
                    {...methods.register("description")}
                />

                <Controller
                    name="cost"
                    control={methods.control}
                    render={({ field }) => {
                        return (
                            <TextField {...field} id="cost" label="Custo" variant="outlined"
                              
                                onChange={(e) => {
                                    const value = e.target.value.replace(/[^0-9]/g, '');
                                    field.onChange(value);
                                }}

                            />
                        );
                    }}
                />

                <Controller
                    name="custom_status_id"
                    control={methods.control}
                    render={({ field }) => {
                        const options = status.map((s) => ({
                            label: s.name,
                            value: s.id
                        }));
                        
                        const selectedOption = options.find(option => option.value === field.value) || null;
                        
                        return (
                            <Autocomplete
                                id="custom_status_id"
                                options={options}
                                value={selectedOption}
                                getOptionLabel={(option) => option?.label || ''}
                                isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                onChange={(_, data) => field.onChange(data?.value || '')}
                                renderInput={(params) => <TextField {...params} label="Status Customizado" />}
                            />
                        );
                    }}
                />
                <TextField
                    id="hours"
                    label="Horas"
                    variant="outlined"
                    name="hours"
                    {...methods.register("hours")}
                />

                <TextField
                    id="minutes"
                    label="Minutos"
                    variant="outlined"
                    name="minutes"
                    {...methods.register("minutes")}
                />
                <Controller
                    name="active"
                    control={methods.control}
                    render={({ field }) => {
                        return (
                            <Box display='flex' flexDirection='row' className='gap-1' alignItems='center'>
                                <Checkbox {...field} id="active" label="Ativo" checked={field.value} onChange={(e) => field.onChange(e.target.checked)} />
                                <Typography>Ativo</Typography>
                            </Box>
                        );
                    }}
                />

            </Box>
        </Filter>

    )
}